import { render, staticRenderFns } from "./ClassModal.vue?vue&type=template&id=d2860e6e&scoped=true&"
import script from "./ClassModal.vue?vue&type=script&lang=js&"
export * from "./ClassModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassModal.vue?vue&type=style&index=0&id=d2860e6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2860e6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClassBox: require('/builds/mytia/mege-educacional/components/ClassBox.vue').default,AppNoContent: require('/builds/mytia/mege-educacional/components/AppNoContent.vue').default,AppSpin: require('/builds/mytia/mege-educacional/components/AppSpin.vue').default,AppModal: require('/builds/mytia/mege-educacional/components/AppModal.vue').default})
